module.exports = __webpack_public_path__ + "03d3c2c64daa1655909a91e3dad9378f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-18.png
// module id = 3063
// module chunks = 0